export const formatDuration = (durationInMinutes) => {
  const totalMinutes = Math.max(0, Math.round(Number(durationInMinutes) || 0));

  if (totalMinutes < 60) {
    return `${totalMinutes} ${totalMinutes === 1 ? 'min' : 'mins'}`;
  }

  const totalHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  const parts = [];

  if (days) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  if (hours) parts.push(`${hours} ${hours === 1 ? 'hr' : 'hrs'}`);
  if (minutes) parts.push(`${minutes} ${minutes === 1 ? 'min' : 'mins'}`);

  if (days) return parts.join(' ');

  const hourLabel = `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;

  return minutes
    ? `${hourLabel} ${minutes} ${minutes === 1 ? 'min' : 'mins'}`
    : hourLabel;
};
